module.exports = __webpack_public_path__ + "img/bofang.3c110d9e.svg";